import en from './en';
import vi from './vi';

export const definitions = {
  en,
  vi
};
